<app-eca-modal-host
                    [heading]="heading"
                    (saveClicked)="saveCompanyDetails()"
                    (editClicked)="editCompanyDetails()"
                    (cancelClicked)="cancelClicked()"
                    [isEditing]="editing"
                    [yesButtonIcon]="['far', 'save']"
                    [noButtonIcon]="['far', 'times']"
                    [editButtonIcon]="['far', 'edit']"
                    noButtonColour="transparent">
  <app-company-details>

  </app-company-details>
</app-eca-modal-host>
